<template>
    <form class="c-o-request-form-main">
        <!-- commentary about this: ":class="{'c-o-request-form-main__inner--border-bottom': form.data.steps.length !== stepIndex + 1}" -->
        <!-- Border bottom will show if the form step isn't the last one.-->
        <!-- commentary about this: ":class="{'c-o-request-form-main__inner--border-bottom': stepIndex !== 0 }" -->
        <!-- Border bottom will also show if it is not the first step. The first step is a dynamic step, however it will always have two standard questions. To prevent having to manually add them to each individual form of the first step, the two standard questions were added as a standalone step with the title 'other information'.
    As border-bottom is always displayed on each step and we need to have the 'other information' look as part of the first step, the border bottom will not show on the first step.-->
        <div
            v-for="(stepData, stepIndex) in form.data.steps"
            :key="`request-form-step-${stepIndex + 1}`"
            class="c-o-request-form-main__inner"
            :class="{
                'c-o-request-form-main__inner--border-bottom':
                    form.data.steps.length !== stepIndex + 1 && stepIndex !== 0
            }"
        >
            <!-- In case the title of the step is 'other information', the title will not be displayed. This is so the standard 'other information' step looks a part of the first step -->
            <div
                v-if="stepData.title !== 'Andra upplysningar'"
                class="c-o-request-form-main__heading"
                ref="form-heading"
            >
                <div class="c-o-request-form-main__heading-circle">
                    <!-- As the 'other information' step was added to look as part of the first step and it's heading number isn't displayed, only the first step needs to add one to it's index to display a correct heading number on the remaining steps. -->
                    <span
                        v-if="stepIndex === 0"
                        class="c-o-request-form-main__heading-number"
                        >{{ stepIndex + 1 }}.</span
                    >
                    <span v-else class="c-o-request-form-main__heading-number"
                        >{{ stepIndex }}.</span
                    >
                </div>
                <h2 class="c-o-request-form-main__heading-title">
                    {{ stepData.title }}
                </h2>
            </div>

            <div v-if="stepIndex === 0" class="c-o-request-form-main__block">
                <div class="c-o-request-form-main__block-inner">
                    <label class="c-a-input__label">Kategori *</label>
                    <drilldown
                        class="c-a-drilldown--vertically-compact"
                        :dimLights="false"
                        :items="categories"
                        :placeholder="drilldownPlaceholder"
                        v-model="category"
                    ></drilldown>
                </div>
            </div>

            <transition-group
                tag="div"
                class="c-o-request-form-main__blocks"
                name="c-o-request-form-main__block--animation"
            >
                <div
                    v-for="question in stepData.questions"
                    v-if="!question.disabled"
                    :ref="`form-item-${stepIndex}-${question.id}`"
                    :key="`form-item-${stepIndex}-${question.id}`"
                    class="c-o-request-form-main__block c-o-request-form-main__block--animation"
                >
                    <div class="c-o-request-form-main__block-inner">
                        <keep-alive>
                            <components
                                :is="question.type"
                                v-bind="questionFilter(question)"
                                v-on:updateData="
                                    upsertAnswer($event, stepIndex)
                                "
                                class="c-o-request-form-main__field"
                                :class="{
                                    'c-o-request-form-main__field--invalid-animation':
                                        question.invalid
                                }"
                            />
                        </keep-alive>
                    </div>
                </div>
            </transition-group>
        </div>
        <div class="c-o-request-form-main__buttons">
            <div class="c-o-request-form-main__button-block">
                <form-button
                    :modifiers="'c-a-button--theme-secondary-light '"
                    :icon="'check_circle'"
                    :label="'Skicka'"
                    @buttonClicked="sendForm"
                ></form-button>
            </div>
        </div>
    </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
    ADD_FILES,
    ADD_STATIC_FORM_ANSWER,
    GET_FORM,
    IS_FORM_VALID,
    SEND_FORM_RESULT,
    UPSERT_ANSWER,
    VALIDATE_FORM,
    VALIDATE_SINGLE_QUESTION
} from "../../../store/store-models/request-form-model.js";

import { GET_REGION } from "../../../store/store-models/companies-model.js";
import { GET_LINKS } from "../../../store/store-models/meta-model.js";

import { IS_CUSTOMER } from "../../../store/store-models/authentication-model.js";

import { GET_CATEGORIES } from "../../../store/store-models/filters-model";

import {
    FETCH_CUSTOMER_BY_ID,
    GET_CUSTOMER_DATA
} from "../../../store/store-models/my-pages-customer-model.js";

import FormButton from "../atoms/AtomButton.vue";
import Drilldown from "../atoms/form/AtomDrilldownCategories.vue";
import InputTextStandard from "../atoms/form/AtomInputText.vue";
import Checkbox from "../atoms/request-form/AtomCheckboxRequestForm.vue";
import Checkboxes from "../atoms/request-form/AtomCheckboxesRequestForm.vue";
import FileUpload from "../atoms/request-form/AtomFileUploadRequestForm.vue";
import RegionSelect from "../atoms/request-form/AtomInputAutocompleteRegionRequestForm.vue";
import InputEmail from "../atoms/request-form/AtomInputEmailRequestForm.vue";
import InputUnit from "../atoms/request-form/AtomInputNumberWithUnitRequestForm.vue";
import InputPhone from "../atoms/request-form/AtomInputPhoneRequestForm.vue";
import InputPersonalNumber from "../atoms/request-form/AtomInputSocialSecurityNumber";
import InputText from "../atoms/request-form/AtomInputTextRequestForm.vue";
import Radio from "../atoms/request-form/AtomRadioRequestForm.vue";
import SecureJobs from "../atoms/request-form/AtomSecureJobsRequestForm";
import SelectBox from "../atoms/request-form/AtomSelectRequestForm.vue";
import TextArea from "../atoms/request-form/AtomTextareaRequestForm.vue";
import VaMemberId from "../atoms/request-form/AtomVaMemberId.vue";

export default {
    data() {
        return {
            chosenCategory: null
        };
    },
    async asyncData({ store }) {
        if (store.getters[IS_CUSTOMER]) {
            await store.dispatch(FETCH_CUSTOMER_BY_ID);
            const { User } = store.getters[GET_CUSTOMER_DATA];
            if (User) {
                store.commit(ADD_STATIC_FORM_ANSWER, {
                    dataKey: "Name",
                    answer: User.Name
                });
                store.commit(ADD_STATIC_FORM_ANSWER, {
                    dataKey: "Email",
                    answer: User.Email
                });
                store.commit(ADD_STATIC_FORM_ANSWER, {
                    dataKey: "Phone",
                    answer: User.Phone
                });
            }
        }
    },
    components: {
        RegionSelect,
        SelectBox,
        Checkboxes,
        Radio,
        FileUpload,
        TextArea,
        InputText,
        InputUnit,
        InputEmail,
        InputPhone,
        VaMemberId,
        Checkbox,
        FormButton,
        InputTextStandard,
        SecureJobs,
        InputPersonalNumber,
        Drilldown
    },
    computed: {
        ...mapGetters({
            form: GET_FORM,
            isFormValid: IS_FORM_VALID,
            isCustomer: IS_CUSTOMER,
            customerData: GET_CUSTOMER_DATA,
            selectedRegion: GET_REGION,
            categories: GET_CATEGORIES
        }),
        userInfo: function() {
            // get customer user data
            if (this.isCustomer && this.customerData.User) {
                return this.customerData.User;
            }
        },
        category: {
            get() {
                this.chosenCategory;
            },
            set(val) {
                this.setCategory(val);
            }
        },
        drilldownPlaceholder: function() {
            return this.form.data.subCategory || "Beskriv eller välj kategori";
        }
    },
    methods: {
        ...mapActions({
            validateForm: VALIDATE_FORM,
            validateQuestion: VALIDATE_SINGLE_QUESTION,
            sendFormResult: SEND_FORM_RESULT,
            fetchCustomerById: FETCH_CUSTOMER_BY_ID
        }),
        ...mapMutations({
            addStaticFormAnswer: ADD_STATIC_FORM_ANSWER
        }),
        async upsertAnswer(data, step) {
            if (data.files) {
                // file
                data.step = step;
                await this.$store.commit(ADD_FILES, data);
                return;
            }

            await this.$store.dispatch(UPSERT_ANSWER, data);
            let validationData = {
                step: step,
                questionId: data.questionId
            };
            await this.validateQuestion(validationData);
        },
        questionFilter(question) {
            if (question.dataKey === "ApproveTerms") {
                const link = this.$store.getters[GET_LINKS]["user_terms_link"];
                question.label = `<p>Jag godkänner de <a target="_blank" href="${link}">allmänna villkoren</a></p>`;
            }

            if (question.dataKey === "RegionId" && this.selectedRegion) {
                question.selected = this.selectedRegion;
            }

            // if there is a customer logged in, get the name, email and phone of customer.
            if (this.userInfo) {
                if (question.dataKey === "Name") {
                    question.userInfo = this.userInfo.Name;
                }

                if (question.dataKey === "SocialSecurityNumber") {
                    question.userInfo = this.form.answersData.SocialSecurityNumber;
                }

                if (question.dataKey === "Email") {
                    question.userInfo = this.userInfo.Email;
                }

                if (question.dataKey === "Phone") {
                    question.userInfo = this.userInfo.Phone;
                }

                if (question.dataKey === "Newsletter") {
                    if (this.userInfo.Newsletter === true) {
                        question.checked = "checked";
                    }
                }
            }

            return question;
        },
        resetForm() {
            this.$emit("resetForm");
        },
        async sendForm() {            
            await this.validateForm();

            if (this.isFormValid) {
                window.dataLayer.push({
                    event: "lead_form",
                    email: this.form.answersData.Email
                });

                this.$emit("requestDone");
                await this.sendFormResult();
            } else {
                this.scrollToFirstInvalid();
            }
        },
        scrollToFirstInvalid() {
            let invalidQuestions = [];
            this.form.data.steps.forEach((step, stepIndex) => {
                step.questions.forEach(question => {
                    if (question.invalid) {
                        invalidQuestions.push({
                            questionId: question.id,
                            step: stepIndex
                        });
                    }
                });
            });
            this.$refs[
                `form-item-${invalidQuestions[0].step}-${invalidQuestions[0].questionId}`
            ][0].scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        },
        setCategory(value) {
            this.chosenCategory = value;
            this.$router.push({ path: `/skapa-forfragan/${value.Id}/` });
        }
    },
    async created() {
        if (this.isCustomer) {
            this.addStaticFormAnswer({
                dataKey: "Name",
                answer: this.userInfo.Name
            });
            this.addStaticFormAnswer({
                dataKey: "Email",
                answer: this.userInfo.Email
            });
            this.addStaticFormAnswer({
                dataKey: "Phone",
                answer: this.userInfo.Phone
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismRequestFormMain.vue